import {Card} from "../../generic/card";
import {AsRoute} from "../../../app";
import {Row, Table} from "../../generic/table";
import {WithAPI} from "../../../api/temperature";
import {useFetchAndRender} from "../../fetchAndRender";
import {DateTime} from "../../generic/date";
import {ExistingToken} from "../../../api/admin";
import {useState} from "preact/hooks";
import {mdiClose, mdiPencil, mdiPlus} from "@mdi/js";
import {ComponentChild} from "preact";
import {useAlert} from "../../generic/alert";
import {Badge} from "../../generic/badge";
import {ButtonList, IconButton} from "../../generic/button";
import {CreateApiKey, ModifyApiKey} from "./components/apiKeyDialog";
import {useFlash} from "../../generic/flash";

/**
 * TODO:
 * - Set expiration date (create / modify / null)
 */

export function ApiKeysAdmin(props: AsRoute & WithAPI) {
    const [result, reloadKeys] = useFetchAndRender(() => {
        return props.api.admin.apiKeys();
    }, {interval: 0});

    const [scopes] = useFetchAndRender(() => {
        return props.api.admin.tokenScopes();
    }, {interval: 0});

    const [addApiKey, triggerAddApiKey] = useState<boolean>(false);
    const [modifyApiKey, setModifyApiKey] = useState<ExistingToken | null>(null);

    const {showConfirm} = useAlert();
    const {success} = useFlash();

    return <Card title={"API Keys"}>
        <Table columns={[
            {id: "key", title: "Name"},
            {id: "ip", title: "IP"},
            {id: "scopes", title: "Scopes"},
            {id: "expires", title: "Expires"},
            {id: "actions", class: "td-shrink text-right", title: <>
                <IconButton
                    disabled={!scopes}
                    className="btn"
                    onClick={() => {triggerAddApiKey(true)}}
                    title="Create new API key"
                    path={mdiPlus}
                />
            </>}
        ]}>{result?.tokens.map(token =>
            <Row key={token.id} cells={{
                "key": <th>{token.name}</th>,
                "ip": <td><code>{token.ipRegEx}</code></td>,
                "scopes": <td>{token.scope
                    .map(scope => <Badge as="code" accent="muted">{scope}</Badge>)
                    .reduce((prev, curr) =>
                        !prev.length ? [curr] : [...prev, <>, </>, curr]
                    , [] as ComponentChild[])}</td>,
                "expires": <td>{token.until ? <DateTime value={token.until} /> : <small>Never</small>}</td>,
                "actions": <td class="td-shrink"><ButtonList>
                    <IconButton className="btn" onClick={() => {
                        setModifyApiKey(token);
                    }} title="Modify API Key" path={mdiPencil} />
                    <IconButton className="btn" onClick={async () => {
                        if (await showConfirm("Remove API key?", "Do you really want to remove this API key?") == "yes") {
                            await props.api.admin.removeApiKey(token.id);
                            success(`API key ${token.name} has been removed.`);
                            reloadKeys();
                        }
                    }} title="Remove API key" path={mdiClose} />
                </ButtonList></td>
            }}/>
        )}</Table>

        {scopes && <CreateApiKey api={props.api} open={addApiKey} onOpenChange={(show) => {
            triggerAddApiKey(show);
            if (!show) {
                reloadKeys(true);
            }
        }} scopes={scopes} />}

        {scopes && modifyApiKey && <ModifyApiKey api={props.api} open={true} token={modifyApiKey} onOpenChange={(show) => {
            if (!show) {
                setModifyApiKey(null);
                reloadKeys(true);
            }
        }} scopes={scopes} />}
    </Card>;
}
